import React, { useState, useEffect } from 'react';
import rectangleImage from '../Rectangle 15.png';

const BackgroundImage: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const projectsSection = document.getElementById('projects');
      if (!projectsSection) return;

      const rect = projectsSection.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      
      // Start showing when the projects section is approaching (about 50% of viewport height away)
      const startShowingDistance = viewportHeight * 0.5;
      
      // Calculate how close we are to the projects section
      const distanceFromTop = rect.top - viewportHeight;
      
      if (distanceFromTop <= startShowingDistance) {
        // If we're within the start showing distance, calculate opacity based on distance
        const newOpacity = Math.min(1, 1 - (distanceFromTop / startShowingDistance));
        setOpacity(newOpacity);
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setOpacity(0);
      }

      // Start fading out when scrolling past the projects section
      if (rect.bottom < viewportHeight) {
        const fadeOutDistance = 300; // pixels to fade out over
        const fadeOutOpacity = Math.max(0, rect.bottom / fadeOutDistance);
        setOpacity(fadeOutOpacity);
        if (fadeOutOpacity === 0) {
          setIsVisible(false);
        }
      }
    };

    // Initial check
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div 
      className={`fixed inset-0 pointer-events-none overflow-hidden transition-opacity duration-300 ${
        isVisible ? 'block' : 'hidden'
      }`}
      style={{ opacity }}
    >
      {/* Orange glow overlay with reduced intensity */}
      <div 
        className="absolute inset-0 z-[1]"
        style={{
          background: 'radial-gradient(circle at center, rgba(255, 140, 50, 0.08) 0%, rgba(255, 140, 50, 0.03) 50%, transparent 100%)',
          mixBlendMode: 'overlay'
        }}
      />
      <img 
        src={rectangleImage}
        alt="Background decoration"
        className="absolute left-1/2 top-[50vh] -translate-x-1/2 -translate-y-1/2 w-full max-w-[90vw] opacity-[0.7]"
        style={{ zIndex: 0 }}
      />
    </div>
  );
};

export default BackgroundImage; 